import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-checkbox',
    templateUrl: './checkbox.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CheckboxComponent {

  @Input() checked = false;
  @Output() valueChange = new EventEmitter<boolean>();

  toggleValue() {
    this.checked = !this.checked;
    this.valueChange.emit(this.checked);
  }
}
